export default __webpack_public_path__ + "static/media/emoji.3549a541.svg";